<template lang="pug">
  main
    NavBarInventario
    ModalDelete(v-show="modalStatusDel" :title="titleModalDel" :content="contentModalDel" @padre:eliminar="deleteCat")
    ModalInfo(v-show="modalStatus" :title="titleModal" :content="contentModal" @padre:close="cerrarModal")
    Loader(v-show="isLoading")
    section.section(v-show="!isLoading")
      .container
        .columns
          .column.is-half.is-offset-one-quarter.has-text-centered
            p.title Listado de Categorías
              | &nbsp
              a.button.is-dark.is-rounded.is-medium(@click="backPage")
                i.fas.fa-times
        .columns(v-show="hayDatos")
          .column.is-4
            .columns
              h5.title Categorías
              | &nbsp
              a.button.is-black.is-rounded.is-small(@click="newTipo()" v-show="!agregandoTipo")
                i.fas.fa-plus
                | &nbsp Categoría
            .columns
              .field
                .control
                  input.input.is-primary(
                    type='text', 
                    placeholder='Filtrar categorías',
                    v-model="filterCats",
                  )
            .columns(v-show="result_query != ''")
              .column.is-offset-8.is-4
                span.tag.is-black.is-small {{ result_query }}
            .columns
              div.div_scroll
                vueCustomScrollbar.scroll-area(:settings="settings" @ps-scroll-y="scrollHanle")
                  nav#panelCats.panel
                    div(v-for="(data, index) in categorias_show" :key="data.id")
                      a.panel-block.itemsCats(@click="mostrarSubs(data, index)")
                        span.panel-icon
                          i.fas.fa-desktop(aria-hidden='true')
                        |     {{ data.nombre }}
                        | &nbsp
                        a.button.is-danger.is-rounded.is-small(@click="eliminarCat(data)")
                          span.icon.is-small
                            i.fas.fa-times
          .column.is-8
            NewTipo(@closeTipo="cerrarComponenteTipo" v-show="agregandoTipo")
            ListSubCategorias(:categoriaSel="catSelected" v-show="mostrandoSubs")

        .columns(v-show="!hayDatos")
          .column.is-4.is-offset-4
            .notification.is-danger No existen Registros aún en la Base de Datos.
</template>

<script>
import Loader from '../shared/Loader.vue'
import HeaderInventario from './layout/HeaderInventario.vue'
import NavBarInventario from './layout/NavBarInventario.vue'
import InventarioServices from '../../services/inventario/inventario'
import ModalDelete from '@/components/shared/ModalDelete.vue'
import ModalInfo from '@/components/shared/ModalInfo.vue'
import NewTipo from '@/components/inventario_Componentes/NewTipo.vue'
import ListSubCategorias from '@/components/inventario_Componentes/ListSubCategorias.vue'
import vueCustomScrollbar from 'vue-custom-scrollbar'

export default {
  name: 'Tipos',
  components: { Loader, NavBarInventario, HeaderInventario, NewTipo, ModalDelete, ModalInfo, ListSubCategorias, vueCustomScrollbar },
  data () {
    return {
      isLoading: true,
      categorias: [],
      categorias_show: [],
      hayDatos: false,
      agregandoTipo: false,
      modalStatusDel: false,
      contentModalDel: '',
      titleModalDel: '',
      catToDelete: {},
      modalStatus: false,
      contentModal: '',
      titleModal: '',
      catSelected: {},
      mostrandoSubs: false,
      settings: {
        maxScrollbarLength: 60
      },
      filterCats: '',
      result_query: ''
    }
  },
  watch: {
    filterCats() {
      console.log(this.filterCats)
      const CATS = this.filterCats.toUpperCase()
      const catFiltradas = this.categorias.filter( cats => { 
        return `${cats.nombre}`.toUpperCase().includes(CATS)
      }) 
      console.log(catFiltradas)
      this.categorias_show = catFiltradas
      if (this.filterCats !== '') {
        this.result_query = this.categorias_show.length === 1 ? `Se encontró ${this.categorias_show.length} coincidencia.` : `Se encontraron ${this.categorias_show.length} coincidencias.`
      } else {
        this.result_query = ''
      }
    }
  },
  methods: {
    obtenerCategorias () {
      InventarioServices.getCategorias()
        .then(res => {
          console.log(res.data)
          if (res.data.length > 0) {
              this.categorias = res.data.map(this.convertirCategorias)
              this.categorias_show = this.categorias
              this.isLoading = false
              this.hayDatos = true
          } else {
            this.isLoading = false
            this.hayDatos = false
          }
        })
    },
    convertirCategorias(cat) {
      return {
        ...cat,
        isConsumible: parseInt(cat.isConsumible),
        isServicio: parseInt(cat.isServicio),
        responsiva: parseInt(cat.responsiva),
        tipo: parseInt(cat.tipo),
      }
    },
    newTipo () {
      this.agregandoTipo = true
      this.mostrandoSubs = false
    },
    cerrarComponenteTipo () {
      this.agregandoTipo = false
      this.obtenerCategorias()
    },
    mostrarSubs (cat, index) {
      this.unSelectCats()
      this.result_query = ''
      let cats = Array.from(document.querySelectorAll('.itemsCats'))
      cats[index].classList.add('is-active')
      this.catSelected = cat
      this.isLoading = true
      setTimeout(() => {
        this.isLoading = false
        this.mostrandoSubs = true
        this.agregandoTipo = false
      }, 100)
    },
    unSelectCats() {
      let cats = Array.from(document.querySelectorAll('.itemsCats'))
      cats.forEach(element => {
        element.classList.remove('is-active')
      });
    },
    eliminarCat(cat) {
      if (cat) {
        this.catToDelete = cat
        this.titleModalDel = 'Eliminar.'
        this.contentModalDel = `¿Seguro desea eliminar ${cat.nombre}?`
        this.modalStatusDel = true
      }
    },
    deleteCat(result) {
      this.isLoading = true
      if (result === 'delete') { 
        this.isLoading = true
        InventarioServices.deleteCategoria(this.catToDelete.id)
          .then(data => {
            this.isLoading = false
            this.displayToast(data.success ? 'toasted-primary': 'bubble', data.respuesta, data.success ? 'done' : 'ban', 'OK')
            this.obtenerCategorias()
          })
          .catch( e => {
            this.isLoading = false
            this.displayToast('bubble', `Error: ${e.message}`, 'ban', 'OK')
          })
        this.modalStatusDel = false
      }
    },
    cerrarModal () {
      this.modalStatus = false
    },
    scrollHanle(evt) {
      
    },

    displayToast(tema,text, icon, actionText) {
      let toast = this.$toasted.show(text, { 
        theme: tema, 
        position: "bottom-right", 
        duration : 3000,
        iconPack: 'fontawesome',
        icon: icon,
        action : {
          text : actionText,
          onClick : (e, toastObject) => {
            toastObject.goAway(0)
          }
        },
      })
    },
    backPage() {
      this.$router.back()
    }
    
  }, 
  created () {
    this.obtenerCategorias()
    setTimeout(() => {
      this.isLoading = false
    }, 500)
  }
}
</script>

<style scoped>
  .scroll-area {
    position: relative;
    margin: auto;
    height: 400px;
    /* border-radius: 5px 5px 5px 5px; */
    /* border: 1px solid #00d1b2; */
  }
  .ps__thumb-x, .ps__thumb-y {
    background-color: #00d1b2;
    width: 10px;
  } 

  .div_scroll {
    margin-top: 20px;
  }
  
</style>



// WEBPACK FOOTER //
// src/components/inventario_Componentes/Tipos.vue